import { render } from "./UsersForm.vue?vue&type=template&id=a543c5a6&scoped=true"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"

import "./UsersForm.vue?vue&type=style&index=0&id=a543c5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a543c5a6"]])

export default __exports__